<template>
    <video
        disableremoteplayback
        disablepictureinpicture
        muted
        playsinline
        preload="auto"
        x-webkit-airplay="deny"
        class="aspect-ratio"
        style="--aspect-ratio: 16/9"
    >
        <source :src="videoURL" type="video/mp4" />
    </video>
</template>
<script>
export default {
    name: "VideoChapter",
    props: {
        videoSrc: {
            type: String,
            default: "",
        },
    },
    computed: {
        videoURL() {
            return (
                process.env.VUE_APP_API_BASE_URL + this.videoSrc + "#t=0.001"
            );
        },
    },
};
</script>
<style scoped>
.aspect-ratio {
    aspect-ratio: var(--aspect-ratio);
}

@supports not (aspect-ratio: 16 / 9) {
    .aspect-ratio::before {
        float: left;
        padding-top: calc(100% / (var(--aspect-ratio)));
        content: "";
    }

    .aspect-ratio::after {
        display: block;
        content: "";
        clear: both;
    }
}
</style>
